import { UserContext } from './user-context.types';
import { WO_CONTEXT_HEADER } from './user-context.config';

import { environment } from '@wo-environments';
import {
  Customer,
  Maybe,
  Role,
  ServiceLocation,
  Site,
  Supplier,
  Locale,
} from '@iss/libs/graphql';

export const encodeUserContext = (userContext: UserContext): string => window.btoa(JSON.stringify(userContext));

type UserContextInput = Readonly<{
  role?: Maybe<Role>;
  country?: Maybe<Locale>;
  customer?: Maybe<Customer['id']>;
  site?: Maybe<Site['id']>;
  serviceLocation?: Maybe<ServiceLocation['id']>;
  supplier?: Maybe<Supplier['id']>;
}>;

export const createUserContext = ({ role, country, customer, site, serviceLocation, supplier }: UserContextInput): UserContext | null => {
  return role ? { role, country, customer, site, serviceLocation, supplier } : null;
};

export const createUserContextHeader = (input: UserContextInput): string | null => {
  const context = createUserContext(input);
  return context ? encodeUserContext(context) : null;
};

export const debugUserContextHeader = (msg: string, header: string | null): void => {
  if (!environment.production) {
    console.log(msg, WO_CONTEXT_HEADER, header ? window.atob(header) : null);
  }
};
